// ----------------------------------------------- main
import { useEffect, useState } from "react";

// ----------------------------------------------- local
import WebInfoContext from "./WebInfoContext.ts";
import { CategoryInterface } from "../../interfaces/Category";
import useAxios from "../../services/useAxios.tsx";

export default function WebInfo({ children }: { children: JSX.Element }) {
  const { execute: getMainCategory } = useAxios("hashtag/get_main_hashtag");
  // const { execute: getMainOption } = useAxios("/api3/option_list");

  // console.log(getMainOption());
  const [categorys, setCategorys] = useState<CategoryInterface[]>([]);
  // const [options, setOptions] = useState<any[]>([]);
  const [searchQuery, setSearchQuery] = useState("");

  // const [subCategorys,setSubCategorys] = useState<CategoryInterface[]>([]);
  // ---------------------------> Start getCategoryMain

  const getMainCategorys = async () => {
    await getMainCategory().then(({ data }) => {
      setCategorys(
        (data ?? []).filter((obj: any) =>
          [0, 1].includes(+obj?.hashtag?.hashtag_status ?? -1)
        )
      );
    });
  };
  // ---------------------------> End getCategoryMain
  // const getMainOptions = () => {
  //     getMainOption().then((res) => {
  //         setOptions(res.result);
  //     });
  // };

  useEffect(() => {
    getMainCategorys();
    // getMainOptions();
  }, []);
  return (
    <>
      <WebInfoContext.Provider
        value={{
          webInfo: {
            logo: "reza",
            title: "CMS",
            description: "این یک سایت فروشگاهی می باشد",
          },
          categorys,
          // options,
          searchQuery,
          setSearchQuery,
        }}
      >
        {children}
      </WebInfoContext.Provider>
    </>
  );
}
